import React, { memo } from "react";

const BoltIcon = () => {
    return (
        <svg width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity="0.9">
                <path
                    d="M3.60028 2.19922C3.52778 2.19922 3.45662 2.21755 3.39439 2.25239C3.33216 2.28713 3.28127 2.33713 3.24716 2.3968L0.0470241 7.99758C-0.0190449 8.11333 -0.0152964 8.25301 0.0570239 8.36541C0.129344 8.47791 0.259608 8.54666 0.400146 8.54666H2.33376L1.60484 12.9699C1.58725 13.0783 1.62154 13.1884 1.69877 13.2711C1.77591 13.3538 1.88814 13.4007 2.00564 13.3992C2.12305 13.3978 2.23394 13.3483 2.30876 13.2637L7.90907 6.91624H7.90916C7.97353 6.84307 8.00576 6.74966 7.99915 6.65517C7.99255 6.56058 7.94773 6.47192 7.87371 6.40708C7.79969 6.34225 7.70202 6.30609 7.60051 6.30592H5.07395L7.15131 2.7514H7.1514C7.2188 2.63582 7.21604 2.49558 7.14408 2.38232C7.07211 2.26915 6.94158 2.19965 6.80061 2.1994L3.60028 2.19922Z"
                    fill="white"
                    fillOpacity="0.75"
                />
            </g>
        </svg>
    );
};

export default memo(BoltIcon);
